import { Inject, Injectable, Optional } from '@angular/core';

import { PRELOAD } from '../constants';
import { IAtxPreload } from '../interfaces';

@Injectable()
export class AtxPreloadService {
    constructor(@Optional() @Inject(PRELOAD) private readonly preload) {}

    public get(preloadName, type: string = '') {
        return (window as IAtxPreload)[this.preload[0].prefix][type ? `${ type }-${ preloadName }` : preloadName];
    }
}
